import React from "react";

export const YesNoTypeColumnFormatter = (cellContent, row, ind, { dIndexName }) => (
    <span>{dIndexName ? row[dIndexName] ? 'Yes' : 'No' : null}</span>
);

export const YesNoColumnFormatter = (value) => {
    return <span>{value ? 'Yes' : 'No'}</span>
};

